import _ from 'lodash';
import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import * as S from './action-menu-badge.styles';
import image from './provider.png';
import { assembleName, generateLabel } from './util';

export interface IProviderIdBadgeProps {
    className?: string;
    id?: string;
    first?: string;
    suffix?: string;
    last?: string;
    organization?: string;
    path?: string;
    type?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const ProviderBadge: React.FunctionComponent<IProviderIdBadgeProps> = (
    props: IProviderIdBadgeProps,
): React.ReactElement => {
    const { className, id, first, suffix, last, organization, path, type, tooltip, items } = props;
    const name = assembleName(first, last, suffix);

    return (
        <ActionMenuBadge
            className={className}
            label={`${type ? _.capitalize(type) + ' ' : ''} ${generateLabel('Provider', id, name || organization)}`}
            path={path || `/provider/${id}`}
            tooltip={tooltip}
            items={items}
            id={id}
            Symbol={<S.ImageSymbol src={image} />}
        />
    );
};
